import { Wait } from "../wait-helper";
import { AutoFillFormsOptions } from "./auto-fill-forms";
import { getDataByComponentClass } from "./auto-fill-forms-data";

export const autoFillFiller = async (
  ev: KeyboardEvent,
  componentRef: any,
  options: AutoFillFormsOptions
) => {
  let keyBinded = "KeyA";
  if (options.keyBinded || "Alt + A") {
    switch (options.keyBinded) {
      case "Alt + Q":
        keyBinded = "KeyQ";
        break;
      case "Alt + E":
        keyBinded = "KeyE";
        break;
    }
  }

  if (ev.code !== keyBinded || !ev.altKey || !componentRef) {
    return;
  }

  const className = Object.getPrototypeOf(componentRef).constructor.name;
  const classData = getDataByComponentClass(className);

  /**The name of the property that contains the form data */
  const formObjectName = classData.formObjectName;

  const allFormData = classData.formData;

  const callAfterFunctionName = classData.callAfter;

  componentRef[formObjectName] = componentRef[formObjectName] || {};
  Object.keys(allFormData).forEach((name) => {
    componentRef[formObjectName][name] = allFormData[name];
    if (name.startsWith("#")) {
      const element: HTMLInputElement = document.querySelector(name);
      if (element) {
        element.value = allFormData[name];
      }
    }
  });
  if (classData.customFillFunction) {
    classData.customFillFunction(componentRef);
  }

  if (options.shouldSubmit && componentRef[callAfterFunctionName]) {
    await Wait(500);
    componentRef[callAfterFunctionName]();
  }
};



// WEBPACK FOOTER //
// ./src/app/_helpers/auto-fill-forms/auto-fill-forms-filler.ts